<template>
  <div>
    <h5 class="wpcm-top-title" v-if="top_title">{{ props.top_title }}</h5>
    <h3 class="wpcm-popup-title" v-if="title">{{ props.title }}</h3>
    <p class="wpcm-popup-tagline" v-if="tagline">{{ props.tagline }}</p>
  </div>
</template>

<script setup lang="ts">
const props = defineProps(['top_title', 'title', 'tagline']);

</script>